import { TaxIdentifier } from '@dreryk/tax-identifier-common-api';

import { convertDateToLocalDate, useBoolean } from '@dreryk/react-common';

import { InvoiceCreateModal, InvoiceCreateModalLoader } from '~legacy.invoice';
import { protectFeature } from '~libs.shared.system';

type VisitSettlementInvoiceCreateModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type VisitSettlementInvoiceCreateModalOpenerProps = {
   readonly patientId: number;
   readonly taxIdentifier?: TaxIdentifier;
   readonly visitDate: Date | undefined;
   readonly appointmentId: number;
   readonly visitSettlementId: number | undefined;
   readonly children: (renderProps: VisitSettlementInvoiceCreateModalOpenerRenderProps) => JSX.Element | null;
};

export const VisitSettlementInvoiceCreateModalOpener = (
   props: VisitSettlementInvoiceCreateModalOpenerProps
): JSX.Element | null => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return (
      <>
         {props.children({ openModal: openModal })}
         {protectFeature(
            'creatingInvoices',
            modalOpened && props.visitDate && props.visitSettlementId ? (
               <InvoiceCreateModalLoader referenceId={props.visitSettlementId.toString()}>
                  {({ fiscalDocuments, fiscalPrintEnabled }) => (
                     <InvoiceCreateModal
                        onClose={closeModal}
                        patientId={props.patientId}
                        visitDate={convertDateToLocalDate(props.visitDate!)}
                        appointmentId={props.appointmentId}
                        visitSettlementId={props.visitSettlementId!}
                        fiscalDocuments={fiscalDocuments}
                        fiscalPrintEnabled={fiscalPrintEnabled}
                        taxIdentifier={props.taxIdentifier}
                     />
                  )}
               </InvoiceCreateModalLoader>
            ) : null,
            null
         )}
      </>
   );
};
